import gql from 'graphql-tag';

/**
 * Data of the block project-financial-model: the project's attachments and build states of type
 * FIN_MODEL. Read through `Project.blocks.financialModel`, which checks the block's read
 * permission.
 */
export const PROJECT_FINANCIAL_MODEL_FIELDS = gql`
  fragment projectFinancialModelFields on ProjectFinancialModelBlock {
    id
    number
    attachments {
      id
      path
      filename
      displayFilename
      size
      mimetype
      attachmentType
      createdAt
    }
    attachmentBuildStates {
      attachmentType
      state
    }
  }
`;
